import { useCallback } from "react";
import { apiUrls as urls } from "config";
import { useFetchEntity, useFetchPaginatedData, useGetFetcher } from "api";

import { DataFileTemplate } from "interfaces";

interface DataFileMacroCreateSpec {
  name: string;
  reference_data_file: string;
  reference_input_files: string[];
}

export const useCreateDataMacro = () => {
  const url = urls.data_file_templates;

  const fetcher = useGetFetcher();

  return useCallback(
    async (spec: DataFileMacroCreateSpec) => {
      return await fetcher({ url, method: "POST", data: spec });
    },
    [url, fetcher]
  );
};

type TemplateList = Pick<
  DataFileTemplate,
  | "id"
  | "name"
  | "created_time"
  | "reference_data_file"
  | "reference_input_files"
  | "input_columns"
  | "output_columns"
  | "steps"
  | "owner"
>;

export const useFetchDataFileMacroListing = (waitForAll: boolean = false) =>
  useFetchPaginatedData<TemplateList>(urls.data_file_templates);

export const useFetchDataFileMacro = (macroID: string | undefined) =>
  useFetchEntity<DataFileTemplate>(urls.data_file_templates, macroID);

export const useShareDataFileMacro = (macroID: string | undefined) => {
  const url = `${urls.data_file_templates}/${macroID}/share`;
  const fetcher = useGetFetcher();

  return useCallback(
    async (users: string[]) => {
      return await fetcher({ url, method: "POST", data: { users } });
    },
    [url, fetcher]
  );
};
